import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Microscope, TestTube, GraduationCap, Check } from 'lucide-react';
const audiences = [{
  id: 1,
  icon: <Microscope className="w-6 h-6 text-brand-tealLight" data-id="element-229" />,
  title: 'Estudiantes de primer y segundo año',
  description: 'Estás arrancando el ciclo básico y Química Orgánica o Físicoquímica ya te están complicando la vida. BioKit te da apuntes claros desde el día uno, sin perder tiempo armando resúmenes desde cero.',
  bullets: ['Apuntes de todas las materias del ciclo básico', 'Sistema de organización desde el primer cuatrimestre']
}, {
  id: 2,
  icon: <TestTube className="w-6 h-6 text-brand-tealLight" data-id="element-230" />,
  title: 'Estudiantes de ciclo intermedio',
  description: 'Bioquímica Metabólica, Microbiología e Inmunología te tienen contra las cuerdas. BioKit te da los esquemas y mapas conceptuales que necesitás para integrar todo, no solo memorizar de forma suelta.',
  bullets: ['Mapas de vías metabólicas', 'Esquemas de integración por sistema']
}, {
  id: 3,
  icon: <GraduationCap className="w-6 h-6 text-brand-tealLight" data-id="element-231" />,
  title: 'Estudiantes de ciclo superior',
  description: 'Estás llegando a las materias de orientación y necesitás cerrar la carrera de forma ordenada. BioKit te ayuda a no perder organización justo cuando más cerca estás de recibirte.',
  bullets: ['Apuntes de Análisis Clínicos, Genética y Toxicología', 'Herramientas de organización para la recta final']
}];
export function TargetAudience() {
  return <section className="bg-brand-dark py-16 px-4 sm:px-6 lg:px-8" data-id="element-232">
      <div className="max-w-2xl mx-auto" data-id="element-233">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-bold text-center text-white mb-10" data-id="element-234">
          ¿Este sistema es para vos?
        </motion.h2>

        <div className="space-y-6" data-id="element-235">
          {audiences.map((item, index) => <motion.div key={item.id} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white/5 border border-white/10 rounded-2xl p-6" data-id="element-236">
              <div className="flex items-center gap-3 mb-4" data-id="element-237">
                <div className="p-2 bg-brand-teal/20 rounded-lg" data-id="element-238">
                  {item.icon}
                </div>
                <h3 className="text-lg font-bold text-white" data-id="element-239">{item.title}</h3>
              </div>

              <p className="text-gray-300 mb-5 text-[15px]" data-id="element-240">
                {item.description}
              </p>

              <ul className="space-y-2" data-id="element-241">
                {item.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-200" data-id="element-242">
                    <Check className="w-4 h-4 text-brand-tealLight mt-0.5 flex-shrink-0" data-id="element-243" />
                    <span data-id="element-244">{bullet}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}